// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__31JY-","container":"main_container__Qq1fb","quizChoice":"main_quizChoice__1u2nq","title":"main_title__3ijXN"};